<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-input placeholder="设备编号" v-model="devId"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="机构名称" v-model="insName"></el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
    </el-row>

    <el-table
      :data="data"
      border
      stripe
      row-key="id"
      default-expand-all
      style="width: 100%"
      lazy
      :load="load"
      :tree-props="{ children: 'children', hasChildren: 'hasChild' }"
    >
      <el-table-column prop="insName" label="机构名称"> </el-table-column>
      <el-table-column prop="relationName" label="关联名称"> </el-table-column>
      <el-table-column prop="gatewayIds" label="网关编号">
        <template slot-scope="scope">
          <div
            v-if="scope.row.gatewayIds"
            v-html="scope.row.gatewayIds.join('<br>')"
          ></div>
        </template>
      </el-table-column>
      <el-table-column prop="nodeIds" label="节点编号">
        <template slot-scope="scope">
          <div
            v-if="scope.row.nodeIds"
            v-html="scope.row.nodeIds.join('<br>')"
          ></div>
        </template>
      </el-table-column>
      <af-table-column fixed="right" label="操作" width="160">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="onAddLink(scope.row)"
            v-if="scope.row.insName"
            >新增关联</el-button
          >
          <el-button
            type="text"
            size="small"
            @click="onEdit(scope.row)"
            v-if="!scope.row.insName"
            >修改</el-button
          >
          <el-button
            type="text"
            size="small"
            v-if="!scope.row.insName"
            @click="onDelete(scope.row.ids)"
            >删除</el-button
          >
          <el-button
            type="text"
            size="small"
            @click="onNew(scope.row)"
            v-if="!scope.row.insName"
            >重新下发</el-button
          >
        </template>
      </af-table-column>
    </el-table>
    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getInsList"></Pagination>
    </div>

    <el-dialog
      :title="insData.name"
      :visible.sync="open"
      @close="closeDailog"
      width="360"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
      >
        <el-form-item label="关联名称" prop="linkName">
          <el-input
            v-model="ruleForm.linkName"
            placeholder="请输入关联名称"
          ></el-input>
        </el-form-item>
        <el-row :gutter="12">
          <el-col :span="12">
            <div>网关</div>
            <el-table
              border
              :data="gatewayData"
              style="width: 100%"
              @selection-change="onSelectedGateway"
              height="360"
              ref="multipleGateway"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column prop="id" label="设备ID"> </el-table-column>
              <el-table-column prop="romModel" label="型号"> </el-table-column>
              <el-table-column prop="categoryName" label="分类">
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="12">
            <div>节点</div>
            <el-table
              border
              :data="nodeData"
              style="width: 100%"
              @selection-change="onSelectedNode"
              height="360"
              ref="multipleNode"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column prop="id" label="设备ID"> </el-table-column>
              <el-table-column prop="romModel" label="型号"> </el-table-column>
              <el-table-column prop="categoryName" label="分类">
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-form-item>
          <div style="padding-top: 18px; padding-left: 32%">
            <el-button @click="closeDailog">取 消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')"
              >确定</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  name: "admin",
  data() {
    return {
      devId: "",
      insName: "",
      open: false,
      data: [],
      editData: {},
      insData: {},
      gatewayData: [],
      nodeData: [],
      multipleGateway: [],
      multipleNode: [],
      isAdd: false,
      ruleForm: {
        linkName: "",
      },
      rules: {
        linkName: [
          { required: true, message: "请输入关联名称", trigger: "blur" },
        ],
      },
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            gatewayIds: this.multipleGateway.map((i) => i.id),
            insId: this.insData.insId,
            nodeIds: this.multipleNode.map((i) => i.id),
            relationName: this.ruleForm.linkName,
          };
          if(this.insData.ids && !!this.insData.ids.length) {
            params.ids = this.insData.ids
          }
          this.$http
            .post(`/manage/routing-bind/${this.isAdd ? 'addBatch' : 'saveBatch'}`, params)
            .then((rs) => {
              if (rs.data.code == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.open = false;
                window.location.reload();
              } else {
                this.$message({
                  message: rs.data.message,
                  type: "error",
                });
              }
            });
        } else {
          return false;
        }
      });
    },
    onDevList(insId, termType) {
      const params = {
        pageNum: 1,
        pageSize: 99999,
        insId,
        termType,
      };
      this.$http.post("/manage/dev/list", params).then((results) => {
        const value = results["data"]["data"]["records"];
        if (termType === "gateway") {
          this.gatewayData = value;
          if (this.editData && this.editData.gatewayIds) {
            const arr = [];
            this.editData.gatewayIds.forEach((row) => {
              const id = row;
              const filterValue = value.filter((i) => i.id == id);
              !!filterValue.length && arr.push(filterValue[0]);
            });
            this.$nextTick(() => {
              arr.forEach((row) => {
                this.$refs.multipleGateway.toggleRowSelection(row, true);
              });
            });
          }
        }
        if (termType === "node_terminal") {
          this.nodeData = value;
          if (this.editData && this.editData.nodeIds) {
            const arr = [];
            this.editData.nodeIds.forEach((row) => {
              const id = row;
              const filterValue = value.filter((i) => i.id == id);
              !!filterValue.length && arr.push(filterValue[0]);
            });
            this.$nextTick(() => {
              arr.forEach((row) => {
                this.$refs.multipleNode.toggleRowSelection(row, true);
              });
            });
          }
        }
      });
    },
    onEdit(data) {
      console.log(data, "edit");
      const obj = {
        ...data,
        linkName: data.relationName,
      };
      this.open = true;
      this.isAdd = false;
      this.editData = obj;
      this.ruleForm = obj;
      this.insData = obj;
      this.onDevList(this.insData.insId, "node_terminal");
      this.onDevList(this.insData.insId, "gateway");
    },
    onAddLink(data) {
      console.log(data, "link");
      this.open = true;
      this.insData = data;
      this.editData = {};
      this.isAdd = true;
      this.onDevList(data.insId, "node_terminal");
      this.onDevList(data.insId, "gateway");
    },
    onDelete(data) {
      if (confirm("确认要删除吗？")) {
        this.$http.post("/manage/routing-bind/delete", {ids: data}).then((rs) => {
          if (rs.data.code == 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getInsList();
          } else {
            this.$message({
              message: rs.data.message,
              type: "error",
            });
          }
        });
      }
    },
    onNew(data) {
      this.$http
        .post("/manage/routing-bind/syncRouteBinding", data)
        .then((rs) => {
          if (rs.data.code == 0) {
            this.$message({
              message: "重新下发成功",
              type: "success",
            });
          } else {
            this.$message({
              message: rs.data.message,
              type: "error",
            });
          }
        });
    },
    load(tree, treeNode, resolve) {
      console.log(tree, "tree1111");
      if (tree.insName) {
        this.$http
          .post(`/manage/routing-bind/queryTopMergeList`, {
            insId: tree.id,
            syncFlag: false,
          })
          .then((results) => {
            const res = results["data"]["data"]["records"]
              .map((i) => {
                i.id = i.ids.join("");
                i.insId = tree.id;
                return i;
              })
              .filter((i) => !!i.relationName);
            resolve(res);
          });
      }
    },
    onSelectedNode(val) {
      this.multipleNode = val;
    },
    onSelectedGateway(val) {
      this.multipleGateway = val;
    },
    closeDailog() {
      this.open = false;
      this.ruleForm.linkName = "";
    },
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getInsList();
    },
    getInsList() {
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
      };
      if (this.devId.trim() != "") {
        params.deviceId = this.devId;
      }
      if (this.insName.trim() != "") {
        params.insName = this.insName;
      }
      this.$http
        .post(`/manage/routing-bind/queryInstitutionsAllList`, params)
        .then((results) => {
          const res = results["data"]["data"]["records"];
          this.data = res.map((i) => {
            return {
              id: i.id,
              insId: i.id,
              insName: i.name,
              name: i.name,
              hasChild: true,
            };
          });
          this.pagin.total = results["data"]["data"]["total"];
        });
    },
  },
  components: { Pagination },
};
</script>
